import { render, staticRenderFns } from "./CardContentInsuranceCompanies.vue?vue&type=template&id=c5543394&scoped=true&"
import script from "./CardContentInsuranceCompanies.vue?vue&type=script&lang=js&"
export * from "./CardContentInsuranceCompanies.vue?vue&type=script&lang=js&"
import style0 from "./CardContentInsuranceCompanies.vue?vue&type=style&index=0&id=c5543394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5543394",
  null
  
)

export default component.exports